<template>
  <div class="max-w-4xl story-section px-8">
    <div class="text-content">
      <BlockContent
        class="text-xl lg:text-2xl font-serif text-justify-center lg:leading-normal"
        :blocks="text"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    _key: {
      type: String,
      default: '',
    },
    _type: {
      type: String,
      default: '',
    },
    text: {
      type: Array,
      default: () => [],
    },
  },
});
</script>
